// extracted by mini-css-extract-plugin
export default {"root":"EZCZz2","line":"Yim9Yh"};